import { auth } from "../firebase";

export default {
  actions: {
    getUid() {
      const user = auth.currentUser;
      return user ? user.uid : null;
    },

    async login({ commit }, { email, password }) {
      try {
        await auth.signInWithEmailAndPassword(email, password);
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },

    async register({ dispatch, commit }, { email, password, name }) {
      try {
        const { user } = await auth.createUserWithEmailAndPassword(
          email,
          password
        );
        user.sendEmailVerification();
        await dispatch("createUser", { email, name });
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },

    async resetPassword({ commit }, { email }) {
      try {
        await auth.sendPasswordResetEmail(email);
        commit("setError", "reset-password");
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },

    async logout({ commit }) {
      await auth.signOut();
      commit("clearError");
      commit("clearUser");
      commit("clearCourses");
    }
  }
};
